// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"nwxXn","rc-tabs-tab":"iGzA7","rc-tabs-tab-active":"digR3","tip":"_0RXAc","tip-label":"On2Oj","tip-group":"_2KkTv","field":"QxrsO","blink":"oSO6H","geo-icon":"_108bY"};